// @ts-nocheck

import React, { useCallback } from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import Checkbox from '../Checkbox';

const Wrap = styled.div`
  margin: 0.2em 0;
`;

const BonusItem = styled.div`
  display: block;
  width: 100%;
  text-align: left;
  margin: 0.2em 0;
`;

type Bonus = {
  label: string;
  id: number;
};

type BasketBonusListProps = {
  className?: string;
  bonuses: Array<Bonus>;
  selectedBonusId: number | null;
  onSelectBonus: (...params: unknown) => unknown;
  isDisabled: boolean;
};

const BasketBonusList = ({
  className,
  bonuses = [],
  selectedBonusId,
  onSelectBonus = () => {},
  isDisabled,
}: BasketBonusListProps) => {
  const onClick = useCallback(
    (id) => () => {
      if (!isDisabled) {
        onSelectBonus(id);
      }
    },
    [isDisabled, onSelectBonus],
  );
  return bonuses.length ? (
    <Wrap className={className}>
      {__('Use a bonus')}
      {bonuses.map(({ id, label }) => {
        const selected = id === selectedBonusId;
        return (
          <BonusItem key={id} onClick={onClick(selected ? undefined : id)}>
            <Checkbox checked={selected}>{label}</Checkbox>
          </BonusItem>
        );
      })}
    </Wrap>
  ) : null;
};

export default BasketBonusList;
